export function simplifySpecialCharacters(text: string): string {
  return text
    .replace(/[ÀÁÂÃÄÅàáâãäå]/gi, 'A')
    .replace(/[ÍÌÎÏíìîï]/gi, 'i')
    .replace(/[ÓÒÔÖóòôö]/gi, 'i')
    .replace(/[ÈÉÊËéàêë&]/gi, 'e')
    .replace(/[$]/gi, 's')
    .replace(/[ç]/gi, 'c');
}
